import React, { useEffect, useRef, useCallback } from "react";
import "./index.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthController from "controllers/authController";
import routes from "routes/routes";
import Translation from "../translations";
import mainIcon from "assets/images/menuIcons/main.png";
import balanceIcon from "assets/images/menuIcons/balance.png";
import vehiclesIcon from "assets/images/menuIcons/vehicles.png";
import friendsIcon from "assets/images/menuIcons/friends.png";
import partnersIcon from "assets/images/menuIcons/partners.png";
import historyIcon from "assets/images/menuIcons/history.png";
import transactionIcon from "assets/images/menuIcons/transactions.png";
import templatesIcon from "assets/images/menuIcons/templates.png";
import messagesIcon from "assets/images/menuIcons/messages.png";
import stationsIcon from "assets/images/menuIcons/stations.png";
import cardsIcon from "assets/images/menuIcons/cards.png";
import settingsIcon from "assets/images/menuIcons/settings.png";
import signoutIcon from "assets/images/menuIcons/signout.png";
import flashIcon from "assets/images/FlashIcon.png";
import { useSelector } from "react-redux";
import { userDataSelector } from "store/selectors/app";

export default function LeftMenu({
  isMenuOpen = false,
  setIsMenuOpen = () => {},
  menuButtonRef,
}) {
  const location = useLocation();
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const userData = useSelector(userDataSelector);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, [setIsMenuOpen]);

  const handleClickOutside = useCallback(
    (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    },
    [setIsMenuOpen, menuButtonRef]
  );

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen, handleClickOutside]);

  const handleLogout = async () => {
    await AuthController.logout();
    navigate("/login");
  };

  return (
    <>
      {isMenuOpen && (
        <div className="mobile-overlay visible" onClick={closeMenu}></div>
      )}

      <div
        ref={menuRef}
        className={`div-all-left-fileds ${isMenuOpen ? "open" : ""}`}
      >
        <div className="logoPersonal">
          <Link to="/personalAccount">
            <img
              src={flashIcon}
              alt="Flash Logo"
              className="flash-logo-personal"
            />
          </Link>
        </div>

        <div className="div-for-space">
          <div className="div-left-menu">
            <div className="menu-fields">
              <Link to={routes.personalAccount} onClick={closeMenu}>
                <p
                  className={`all-menu-p-fields ${
                    location.pathname === routes.personalAccount ? "active" : ""
                  }`}
                >
                  <img
                    src={mainIcon}
                    alt="mainIcon"
                    className="menu-img-icons"
                  />
                  <Translation label={"_main"} />
                </p>
              </Link>
            </div>

            <div className="menu-fields">
              <Link to={routes.myBalance} onClick={closeMenu}>
                <p
                  className={`all-menu-p-fields ${
                    location.pathname === routes.myBalance ? "active" : ""
                  }`}
                >
                  <img
                    src={balanceIcon}
                    alt="balanceIcon"
                    className="menu-img-icons"
                  />
                  <Translation label={"_myBalance"} />
                </p>
              </Link>
            </div>

            <div className="menu-fields">
              <Link to={routes.MyVehicles} onClick={closeMenu}>
                <p
                  className={`all-menu-p-fields ${
                    location.pathname === routes.MyVehicles ? "active" : ""
                  }`}
                >
                  <img
                    src={vehiclesIcon}
                    alt="vehiclesIcon"
                    className="menu-img-icons"
                  />
                  <Translation label={"_myVehicles"} />
                </p>
              </Link>
            </div>

            {userData?.type === "individual" && (
              <div className="menu-fields">
                <Link to={routes.MyFriends} onClick={closeMenu}>
                  <p
                    className={`all-menu-p-fields ${
                      location.pathname === routes.MyFriends ? "active" : ""
                    }`}
                  >
                    <img
                      src={friendsIcon}
                      alt="friendsIcon"
                      className="menu-img-icons"
                    />
                    <Translation label={"_myFriends"} />
                  </p>
                </Link>
              </div>
            )}

            {userData?.type === "company" && (
              <div className="menu-fields">
                <Link to={routes.MyPartners} onClick={closeMenu}>
                  <p
                    className={`all-menu-p-fields ${
                      location.pathname === routes.MyPartners ? "active" : ""
                    }`}
                  >
                    <img
                      src={partnersIcon}
                      alt="partnersIcon"
                      className="menu-img-icons"
                    />
                    <Translation label={"_myPartners"} />
                  </p>
                </Link>
              </div>
            )}

            <div className="menu-fields">
              <p className="all-menu-p-fields">
                <img
                  src={historyIcon}
                  alt="historyIcon"
                  className="menu-img-icons"
                />
                <Translation label={"_history"} />
              </p>
            </div>

            <div className="menu-fields">
              <Link to={routes.Transactions} onClick={closeMenu}>
                <p
                  className={`all-menu-p-fields ${
                    location.pathname === routes.Transactions ? "active" : ""
                  }`}
                >
                  <img
                    src={transactionIcon}
                    alt="transactionsIcon"
                    className="menu-img-icons"
                  />
                  <Translation label={"_transactions"} />
                </p>
              </Link>
            </div>

            <div className="menu-fields">
              <p className="all-menu-p-fields">
                <img
                  src={templatesIcon}
                  alt="templatesIcon"
                  className="menu-img-icons"
                />
                <Translation label={"_templates"} />
              </p>
            </div>

            <div className="menu-fields">
              <p className="all-menu-p-fields">
                <img
                  src={messagesIcon}
                  alt="messagesIcon"
                  className="menu-img-icons"
                />
                <Translation label={"_messages"} />
              </p>
            </div>

            <div className="menu-fields">
              <Link to={routes.StationsMap} onClick={closeMenu}>
                <p
                  className={`all-menu-p-fields ${
                    location.pathname === routes.StationsMap ? "active" : ""
                  }`}
                >
                  <img
                    src={stationsIcon}
                    alt="stationsIcon"
                    className="menu-img-icons"
                  />
                  <Translation label={"_ourStations"} />
                </p>
              </Link>
            </div>

            <div className="menu-fields">
              <Link to={routes.MyCards} onClick={closeMenu}>
                <p
                  className={`all-menu-p-fields ${
                    location.pathname === routes.MyCards ? "active" : ""
                  }`}
                >
                  <img
                    src={cardsIcon}
                    alt="partnersIcon"
                    className="menu-img-icons"
                  />
                  <Translation label={"_cards"} />
                </p>
              </Link>
            </div>
          </div>

          <div className="div-settings-logout">
            <div className="div-line-2"></div>
            <div className="menu-fields">
              <Link to={"/profile"} onClick={closeMenu}>
                <p
                  className={`all-menu-p-fields ${
                    location.pathname === routes.profile ? "active" : ""
                  }`}
                >
                  <img
                    src={settingsIcon}
                    alt="settingsIcon"
                    className="menu-img-icons"
                  />
                  <Translation label="_settings" />
                </p>
              </Link>
            </div>

            <div className="menu-fields">
              <p
                className={`all-menu-p-fields ${
                  location.pathname === routes.MyCards ? "active" : ""
                }`}
                onClick={handleLogout}
              >
                <img
                  src={signoutIcon}
                  alt="signoutIcon"
                  className="menu-img-icons"
                />
                <Translation label="_logout" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
